<template>
	<div class="relative">
		<div class="h-[517px]">
			<NuxtImg
				:src="curatedList?.creator_details.background_image"
				:width="curatedList?.creator_details.background_width"
				:height="curatedList?.creator_details.background_height"
				sizes="xs:375px sm:640px md:768px lg:1024px xl:1280px 2xl:1440px"
				densities="x1"
				:class="
					heroPhotoPositionVariants({
						position: curatedList?.creator_details.background_position
					})
				"
				format="webp"
				quality="80"
				loading="lazy"
				preload
				fetchpriority="high"
			/>
			<div
				class="absolute inset-0 bg-linear-to-b from-black/40 via-black/20 to-black/40"
			/>
		</div>
		<div class="absolute inset-x-0 top-0 z-30 flex size-full flex-col">
			<Container class="mt-auto self-center px-5 2xl:px-0">
				<div class="flex flex-col gap-y-6">
					<div class="w-fit bg-white-dark-2 px-2 py-[2px]">
						<span
							class="font-matter-sq text-sm uppercase leading-[150%] tracking-[1.12px] text-primary lg:text-base"
						>
							Coleção
						</span>
					</div>
					<div class="flex flex-col gap-y-5">
						<div class="flex items-center gap-x-5">
							<NuxtImg
								v-if="curatedList?.creator_details.image_url"
								:src="curatedList?.creator_details.image_url"
								width="56"
								height="56"
								class="size-[56px] rounded-full"
								format="webp"
								quality="80"
								loading="lazy"
								preload
								fetchpriority="high"
							/>

							<h1
								class="font-matter-sq text-2xl font-normal leading-[150%] tracking-[-2%] text-white lg:text-5xl"
							>
								{{ curatedList?.creator_details.name }}
							</h1>
						</div>
						<div>
							<h3
								class="text-base font-normal leading-[150%] tracking-normal text-white lg:text-xl"
							>
								{{ curatedList?.creator_details.headline }}
							</h3>
						</div>
					</div>
				</div>
			</Container>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { CuratedList } from '~~/core/entities/CuratedList';

import { heroPhotoPositionVariants } from './index';

defineProps<{
	curatedList?: CuratedList;
}>();
</script>
